module.exports = __webpack_public_path__ + "static/media/preview.202bf61a.png";